// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".popper-custom .popper__arrow{border-color:#000 transparent transparent transparent!important}", ""]);
// Exports
module.exports = exports;
